import { baseAPI_V2 } from '../baseAPIV2';

export async function getEmailConfirmation(jwt_token: String) {
  return await baseAPI_V2.get<{}>('/api/v2/confirmation', { params: { jwt: jwt_token } });
}

export async function putEmailConfirmation(jwt_token: String) {
  return await baseAPI_V2.put<{}>('/api/v2/confirmation', { jwt: jwt_token } );
}